/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { DefinitionTooltip, Dropdown } from '@carbon/react';
import styled from 'styled-components';

export const CLUSTER_CONFIGURATION_DOCUMENTATION =
  'https://docs.camunda.io/docs/next/self-managed/modeler/web-modeler/configuration/#clusters';

export default function ClusterSelection({ clusters, selectedCluster, setSelectedCluster, resetDeploymentState }) {
  return (
    clusters.length > 0 && (
      <_Dropdown
        id="cluster-selection-dropdown"
        titleText={
          <DefinitionTooltip
            definition={
              <span role="tooltip">
                Select from a list of pre-configured clusters for deployment. For more information on configuring
                clusters, visit the{' '}
                <a href={CLUSTER_CONFIGURATION_DOCUMENTATION} target="_blank" rel="noreferrer">
                  documentation
                </a>
                .
              </span>
            }
            openOnHover
            align="right"
          >
            Cluster
          </DefinitionTooltip>
        }
        onChange={({ selectedItem }) => {
          setSelectedCluster(selectedItem);
          resetDeploymentState();
        }}
        selectedItem={selectedCluster || null}
        label="Select a cluster"
        aria-label="Select a cluster"
        items={clusters}
        // @ts-ignore
        itemToString={(cluster) => (cluster ? `${cluster.name} (${cluster.version})` : '')}
      />
    )
  );
}

const _Dropdown = styled(Dropdown)`
  .cds--popover-content {
    min-width: 480px;
  }

  a {
    color: var(--tooltip-link);

    &:hover {
      color: var(--tooltip-link);
    }
  }
`;
